const COMBO_LABEL = Object.freeze({
  shatter: 'SHATTER',
  overload: 'OVERLOAD'
});

export class SandboxHUD {
  constructor(root, { onReset, onReducedVfx }) {
    this.root = root;
    this.onReset = onReset;
    this.onReducedVfx = onReducedVfx;
    this.reduced = false;

    root.innerHTML = `
      <section class="lab-card" aria-label="Combat test objectives">
        <header>
          <span>COMBAT TEST</span>
          <strong data-objective>Trigger both reactions</strong>
        </header>
        <div class="lab-combos">
          <div data-combo="shatter"><i></i><span><b>FROST</b> then <b>CINDER</b></span><em>SHATTER</em></div>
          <div data-combo="overload"><i></i><span><b>SNARE</b> then <b>STORM</b></span><em>OVERLOAD</em></div>
        </div>
        <div class="lab-metrics">
          <span>Casts <b data-casts>0</b></span>
          <span>Hits <b data-hits>0</b></span>
          <span>Dummies <b data-defeated>0</b></span>
        </div>
        <div class="lab-actions">
          <button type="button" data-reset><kbd>N</kbd> Reset arena</button>
          <button type="button" data-vfx><kbd>M</kbd> Reduced VFX</button>
        </div>
      </section>
    `;

    this.objective = root.querySelector('[data-objective]');
    this.casts = root.querySelector('[data-casts]');
    this.hits = root.querySelector('[data-hits]');
    this.defeated = root.querySelector('[data-defeated]');
    this.vfxButton = root.querySelector('[data-vfx]');

    root.querySelector('[data-reset]').addEventListener('click', () => this.onReset?.());
    this.vfxButton.addEventListener('click', () => this.onReducedVfx?.());
  }

  update(state) {
    if (!state) return;
    this.casts.textContent = state.casts;
    this.hits.textContent = state.hits;
    this.defeated.textContent = state.defeated;

    for (const [id, label] of Object.entries(COMBO_LABEL)) {
      const complete = state.combos.includes(id);
      const row = this.root.querySelector(`[data-combo="${id}"]`);
      row.classList.toggle('is-complete', complete);
      row.querySelector('em').textContent = complete ? `${label} ✓` : label;
    }

    this.objective.textContent =
      state.combos.length >= 2 ? 'Both reactions confirmed' : 'Trigger both reactions';
  }

  setReducedVfx(reduced) {
    this.reduced = reduced;
    this.vfxButton.classList.toggle('is-active', reduced);
    this.vfxButton.lastChild.textContent = reduced ? ' Full VFX' : ' Reduced VFX';
  }
}

